import React from 'react'

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-900 sm:w-full">
      <div className="relative w-16 h-16">
        {/* Outer Circle */}
        <div className="absolute w-full h-full border-4 border-gray-600 border-t-white rounded-full animate-moonSpin"></div>
        {/* Inner Circle */}
        <div className="absolute top-2 left-2 w-10 h-10 bg-gray-900 rounded-full"></div>
      </div>
    </div>
  )
}

export default Loader